import React, { useContext } from 'react';
import { Container, Row, Col, Table, Spinner, Form } from 'react-bootstrap';
import { AppContext } from '../App';


export const Collections = () => {
	const { collections, getCollectionLoad, getDate, getCollections, getBill, setViewBillModal } = useContext(AppContext);
	return (
		<div className="container-fluid pos-rel" >
			<div className="d-flex justify-content-between align-items-center bgp p-2 br-2">
				<div className='px-2'>
					{
						getCollectionLoad ? (
							<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
						) : (<span>Collections</span>)
					}
				</div>
				<div className="d-grid just-end al-center" >
					<Form.Control onChange={(e) => { getCollections(e.target.value) }} type="date" defaultValue={getDate()} className="br-3" />
				</div>
			</div>

			{
				collections !== undefined ? (
					collections.main.token_count !== undefined ? (
						<>
							<Row className="pt-3">
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status create p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >New tokens</span>
										<span className="d-grid  ts2" >{collections.main.token_count.created}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status open p-2 p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >Processing</span>
										<span className="d-grid  ts2" >{collections.main.token_count.processing}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status cancel p-2 p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >Cancelled</span>
										<span className="d-grid  ts2" >{collections.main.token_count.cancelled}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status close p-2 p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >Completed</span>
										<span className="d-grid  ts2" >{collections.main.token_count.completed}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status p-2 p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >Unsettled Amount</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.token_count.unsettled).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3" >
									<div className="collection-status p-2 p-3 br-3">
										<span className="d-grid f18 tp2 mb-2" >Settled Amount</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.bill_amount_total).toFixed(2)}</span>
									</div>
								</Col>
							</Row>
							<Row className="d-flex" >
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3 d-grid" >
									<div className="collection-status p-2 p-3 br-3  d-grid">
										<span className="d-grid f18 tp2 mb-2" >Service Charges</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.service_day_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3  d-grid" >
									<div className="collection-status p-2 p-3 br-3 d-grid">
										<span className="d-grid f18 tp2 mb-2" >Transaction Charges</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.transaction_day_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3  d-grid" >
									<div className="collection-status p-2 p-3 br-3  d-grid">
										<span className="d-grid f18 tp2 mb-2" >Todays Credit</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.credit_day_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3 d-grid" >
									<div className="collection-status p-2 p-3 br-3  d-grid">
										<span className="d-grid f18 tp2 mb-2" >Todays Debit</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.debit_amount_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3 d-grid" >
									<div className="collection-status p-2 p-3 br-3  d-grid">
										<span className="d-grid f18 tp2 mb-2" >Wallet transaction</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.advance_day_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3 d-grid" >
									<div className="collection-status p-2 p-3 br-3 d-grid">
										<span className="d-grid f18 tp2 mb-2" >Wallet payment</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.customer_wallet_total).toFixed(2)}</span>
									</div>
								</Col>
								<Col xs={12} sm={6} md={4} lg={3} xl={2} className="pb-3 d-grid" >
									<div className="collection-status p-2 p-3 br-3 d-grid">
										<span className="d-grid f18 tp2 mb-2" >Total</span>
										<span className="d-grid  ts2" >{parseFloat(collections.main.grand_day_total).toFixed(2)}</span>
									</div>
								</Col>
							</Row>
						</>
					) : ''
				) : ''
			}
			{
				collections !== undefined && collections.wallet_values !== undefined ? (
					<>
						<span className="d-grid f18 p-2 tp2" >Wallet details</span>
						<Table bordered className="tbl-bg-blue" >
							<thead>
								<tr>
									<th>Date</th>
									<th>Customer</th>
									<th>Staff</th>
									<th className='text-end' >Payment</th>
									<th className="text-end" >Total</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(collections.wallet_values).length > 0 ? (
										Object.keys(collections.wallet_values).map((wc, wci) => (
											<tr key={`wc_$wci`} className="tp2" >
												<td>
													<div className='d-grid'>
														<span className="tp2" >{collections.wallet_values[wc].collected_date}</span>
														<span className="tp2 f14" >{collections.wallet_values[wc].collected_time}</span>
													</div>
												</td>
												<td>
													<div className="d-grid">
														<span className="tp2" >{collections.wallet_values[wc].customer_name}</span>
														<span className="tp2 f14" >{collections.wallet_values[wc].customer_phone}</span>
													</div>
												</td>
												<td><span className="tp2" >{collections.wallet_values[wc].cash_collected}</span></td>
												<td>
													<div className="d-grid">
														{
															collections.wallet_values[wc].ap_payments !== undefined ? (
																Object.keys(collections.wallet_values[wc].ap_payments).length > 0 ? (
																	Object.keys(collections.wallet_values[wc].ap_payments).map((b_pay, b_pay_i) => (
																		<div class="grid8by2 bdr2-b mb-1 px-1" key={`bpay_${b_pay_i}`} >
																			<span className="tp2 f14" >{collections.wallet_values[wc].ap_payments[b_pay].name}</span>
																			<div className='d-flex align-items-center justify-content-end' >
																				<span className="tp2 f14" >{collections.wallet_values[wc].ap_payments[b_pay].amount}</span>
																			</div>
																		</div>
																	))
																) : ''
															) : ''
														}
													</div>
												</td>
												<td className="text-end" >
													{
														collections.wallet_values[wc].amount > 0 ? (
															<span className="text-success">+{collections.wallet_values[wc].amount}</span>
														) : (
															<span className="text-danger">-{collections.wallet_values[wc].amount}</span>
														)
													}
												</td>
											</tr>
										))
									) : 'Wallet Not found!'
								}
								<tr>
									<td colSpan={3} className='text-end bgy' ><span className='f20 tp2' >Total</span></td>
									<td className='bgy' >
										{
											collections !== undefined ? (
												collections.main.advance_total !== undefined ? (
													Object.keys(collections.main.advance_total).length > 0 ? (
														Object.keys(collections.main.advance_total).map((r_pay, r_pay_i) => (
															collections.main.advance_total[r_pay].amount !== 0 ? (
																<div key={`r_pay_x${r_pay_i}`} className='grid8by2 align-items-center justify-content-between bdr0-b mb-1 px-1'>
																	<span className="tp2 " >{collections.main.advance_total[r_pay].name}</span>
																	<div className='d-flex justify-content-end align-items-center'>
																		{

																			collections.main.advance_total[r_pay].amount > 0 ? (
																				<span className="text-success">+{collections.main.advance_total[r_pay].amount}</span>
																			) : (
																				<span className="text-danger">-{collections.main.advance_total[r_pay].amount}</span>
																			)

																		}
																	</div>
																</div>
															) : ''
														))
													) : ''
												) : ''
											) : ''
										}
									</td>
									<td className='text-end bgy' >
										{
											collections !== undefined ? (
												collections.main !== undefined ? (
													<span className="tp2 f20" >{parseFloat(collections.main.advance_day_total).toFixed(2)}</span>
												) : ''
											) : ''
										}
									</td>
								</tr>
							</tbody>
						</Table>
					</>
				) : (<span className='tp2 p-2' >Wallet Not found!</span>)
			}
			{
				collections !== undefined ? (
					collections.debit_values !== undefined && Object.keys(collections.debit_values).length > 0 ? (
						<>
							<span className="d-grid f18 tp2 p-2" >Credit collection details</span>
							<Table bordered className="tbl-bg-blue" >
								<thead>
									<tr>
										<th>Date</th>
										<th>Customer</th>
										<th>Staff</th>
										<th className='text-end' >Payment</th>
										<th className="text-end" >Total</th>
									</tr>
								</thead>
								<tbody>
									{
										Object.keys(collections.debit_values).map((debit, deb_i) => (
											<tr key={`debi_${deb_i}`} >
												<td>
													<div className="d-grid">
														<div className='d-flex align-items-center' >
															<span onClick={() => {
																getBill(collections.debit_values[debit].bill_no);
																setViewBillModal(true);
															}} className='view-bill-link mx-0' ><i className="bi bi-receipt" /> Bill</span>
														</div>
														<span className="tp2" >Invoice : {collections.debit_values[debit].bill_no}</span>
														<span className="tp2 f14" >{collections.debit_values[debit].collected_date}, {collections.debit_values[debit].collected_time}</span>

													</div>
												</td>
												<td>
													<div className='d-grid'>
														<span className="tp2" >{collections.debit_values[debit].customer_name}</span>
														<span className="tp2 f14" >{collections.debit_values[debit].customer_phone}</span>
													</div>
												</td>
												<td><span className="tp2" >{collections.debit_values[debit].cash_collected}</span></td>
												<td>
													<div className="d-grid">
														{
															collections.debit_values[debit].debit_payments !== undefined ? (
																Object.keys(collections.debit_values[debit].debit_payments).length > 0 ? (
																	Object.keys(collections.debit_values[debit].debit_payments).map((b_pay, b_pay_i) => (
																		<div class="grid8by2 bdr2-b mb-1 px-1" key={`bpay_${b_pay_i}`} >
																			<span className="tp2 f14" >{collections.debit_values[debit].debit_payments[b_pay].name}</span>
																			<div className='d-flex align-items-center justify-content-end' >
																				<span className="tp2 f14" >{parseFloat(collections.debit_values[debit].debit_payments[b_pay].amount).toFixed(2)}</span>
																			</div>
																		</div>
																	))
																) : ''
															) : ''
														}
													</div>
												</td>
												<td className="text-end pos-rel" >
													<span className="tp2" >{parseFloat(collections.debit_values[debit].debit_total).toFixed(2)}</span>
												</td>
											</tr>
										))
									}
									{
										collections !== undefined ? (
											collections.main.debit_total !== undefined ? (
												Object.keys(collections.main.debit_total).length > 0 ? (
													Object.keys(collections.main.debit_total).map((r_pay, r_pay_i) => (
														collections.main.debit_total[r_pay].amount > 0 ? (
															<tr key={`r_pay_${r_pay_i}`}>
																<td colSpan={3} className="text-end bgy" ><span className="f20" >Total</span></td>
																<td className="bgy" >
																	<div className='grid8by2 bdr0-b py-1 align-items-center justify-content-between' >
																		<span className="" >{collections.main.debit_total[r_pay].name}</span>
																		<div className='d-flex align-items-center justify-content-end' >
																			<span className="" >{parseFloat(collections.main.debit_total[r_pay].amount).toFixed(2)}</span>
																		</div>
																	</div>
																</td>
																<td className="text-end bgy" ><span className='f20' >{parseFloat(collections.main.debit_amount_total).toFixed(2)}</span></td>
															</tr>
														) : ''
													))
												) : ''
											) : ''
										) : ''
									}
								</tbody>
							</Table>
						</>
					) : ''
				) : ''
			}
			<span className="d-grid f18 tp2 p-2" >Collection details</span>
			<Table bordered className="tbl-bg-blue" >
				<thead>
					<tr>
						<th>Token</th>
						<th>Services</th>
						<th>Customer</th>
						<th>Times</th>
						<th>Payment Methods</th>
						<th className="text-end" >SC</th>
						<th className="text-end tp2" ><span>TC</span></th>
						<th className="text-end" ><span className="tp2" >Total</span></th>
					</tr>
				</thead>
				<tbody>
					{
						collections !== undefined ? (
							collections.bill_values !== undefined ? (
								Object.keys(collections.bill_values).map((tkn, tkn_i) => (
									<tr key={`trep_${tkn_i}`} >
										<td>
											<div className='d-grid'>
												<div className='d-flex'>
													<span onClick={() => {
														getBill(collections.bill_values[tkn].bill_no);
														setViewBillModal(true);
													}} className="view-bill-link" ><i className='bi bi-receipt' ></i> Bill</span>
												</div>
												<span className="tp2 f18" >Token : {collections.bill_values[tkn].token_no}</span>
												<span className="tp2" >Invoice : {collections.bill_values[tkn].bill_no}</span>

											</div>
										</td>
										<td>
											<div className="d-grid">
												{
													collections.bill_values[tkn].bill_services !== undefined ? (
														Object.keys(collections.bill_values[tkn].bill_services).length > 0 ? (
															Object.keys(collections.bill_values[tkn].bill_services).map((t_ser, t_ser_i) => (
																<span className="tp2 " key={`tkrpt_${t_ser_i}`} >{collections.bill_values[tkn].bill_services[t_ser].service_name}{collections.bill_values[tkn].bill_services[t_ser].quantity !== undefined && collections.bill_values[tkn].bill_services[t_ser].quantity > 1 ? (<> ({collections.bill_values[tkn].bill_services[t_ser].quantity})</>) : ''}</span>
															))
														) : ''
													) : ''
												}
											</div>
										</td>
										<td>
											<div className="d-grid">
												<span className="tp2 " >{collections.bill_values[tkn].customer_name}</span>
												<span className="tp2 " >{collections.bill_values[tkn].customer_phone}</span>
											</div>
										</td>
										<td>
											<div className="d-grid">
												<div className="grid8by2  bdr2-b mb-1 px-1">
													<span className="tp2 f14" >Created - {collections.bill_values[tkn].token_created_by}</span>
													<div className="d-flex align-items-center justify-content-end" >
														<span className="tp2 f14" >{collections.bill_values[tkn].created_time}</span>
													</div>
												</div>
												<div className="grid8by2  bdr2-b mb-1 px-1">
													<span className="tp2 f14" >Processed - {collections.bill_values[tkn].token_processed_by}</span>
													<div className="d-flex align-items-center justify-content-end" >
														<span className="tp2 f14" >{collections.bill_values[tkn].open_time}</span>
													</div>
												</div>
												<div className="grid8by2 bdr2-b mb-1 px-1">
													<span className="tp2 f14" >Closed - {collections.bill_values[tkn].token_processed_by}</span>
													<div className="d-flex align-items-center justify-content-end" >
														<span className="tp2 f14" >{collections.bill_values[tkn].close_time}</span>
													</div>
												</div>
											</div>
										</td>
										<td>
											<div className="d-grid">
												{
													collections.bill_values[tkn].bill_payments !== undefined ? (
														Object.keys(collections.bill_values[tkn].bill_payments).length > 0 ? (
															Object.keys(collections.bill_values[tkn].bill_payments).map((b_pay, b_pay_i) => (
																<div className="grid8by2 bdr2-b align-items-center justify-content-between" key={`bpay_${b_pay_i}`} >
																	<span className="tp2 " >{collections.bill_values[tkn].bill_payments[b_pay].name}</span>
																	<div className="d-flex align-items-center justify-content-end" >
																		<span className="tp2 " >{parseFloat(collections.bill_values[tkn].bill_payments[b_pay].amount).toFixed(2)}</span>
																	</div>
																</div>
															))
														) : ''
													) : ''
												}
											</div>
										</td>
										<td className="text-end pos-rel" >
											<span className="tp2 " >{parseFloat(collections.bill_values[tkn].service_bill_total).toFixed(2)}</span>
										</td>
										<td className="text-end pos-rel" >
											<span className="tp2 " >{parseFloat(collections.bill_values[tkn].transaction_bill_total).toFixed(2)}</span>
										</td>
										<td className="text-end pos-rel" >
											<span className="tp2 " >{parseFloat(collections.bill_values[tkn].bill_total).toFixed(2)}</span>
										</td>
									</tr>
								))
							) : ''
						) : ''
					}
					{
						collections !== undefined ? (
							collections.main !== undefined ? (
								<tr>
									<td colSpan={4} className='text-end bgy' ><span className="tp2 f20" >Total</span></td>
									<td className='bgy' >
										{
											collections.main.payments_total !== undefined ? (
												Object.keys(collections.main.payments_total).length > 0 ? (
													Object.keys(collections.main.payments_total).map((r_pay, r_pay_i) => (
														collections.main.payments_total[r_pay].amount > 0 ? (
															<div className="grid8by2 align-items-center justify-content-between bdr0-b py-1" key={`r_pay_${r_pay_i}`} >
																<span className="tp2 " >{collections.main.payments_total[r_pay].name}</span>
																<div className="d-flex align-items-center justify-content-end" >
																	<span className="tp2 " >{parseFloat(collections.main.payments_total[r_pay].amount).toFixed(2)}</span>
																</div>
															</div>
														) : ''
													))
												) : ''
											) : ''
										}
									</td>
									<td className="text-end f18 tp2 bgy" ><span className="tp2 f20" >{parseFloat(collections.main.service_day_total).toFixed(2)}</span></td>
									<td className="text-end f18 tp2 bgy" ><span className="tp2 f20" >{parseFloat(collections.main.transaction_day_total).toFixed(2)}</span></td>
									<td className="text-end f18 tp2 bgy" ><span className="tp2 f20" >{parseFloat(collections.main.bill_amount_total).toFixed(2)}</span></td>
								</tr>
							) : ''
						) : ''
					}
				</tbody>
			</Table>
			{
				collections !== undefined && collections.expense_values !== undefined && Object.keys(collections.expense_values).length > 0 ? (
					<>
						<span className="d-grid f18 tp2 py-2" >Expense details</span>
						<Table bordered className="tbl-bg-blue" >
							<thead>
								<tr>
									<th>Particulars</th>
									<th>Remarks</th>
									<th>Staff</th>
									<th className='text-end' >Payment</th>
									<th className="text-end" >Amount</th>
								</tr>
							</thead>
							<tbody>
								{
									Object.keys(collections.expense_values).map((exp, expi) => (
										<tr key={`expi_${expi}`} className="tc2" >
											<td>
												<span className="d-grid tp2" >{collections.expense_values[exp].particulars}</span>
											</td>
											<td className="tp2" >{collections.expense_values[exp].remarks}</td>
											<td className="tp2" >{collections.expense_values[exp].user}</td>
											<td className="tp2" >
												{
													collections.expense_values[exp].expense_payments !== undefined && Object.keys(collections.expense_values[exp].expense_payments).length > 0 ? (
														Object.keys(collections.expense_values[exp].expense_payments).map((b_pay, b_pay_i) => (
															<div key={`bpay_${b_pay_i}`} className="grid8by2 align-items-center justify-content-between bdr2-b" >
																<span className="tp2 f14" >{collections.expense_values[exp].expense_payments[b_pay].name}</span>
																<div className="d-flex align-items-center justify-content-end" >
																	<span className="tp2 f14" >{parseFloat(collections.expense_values[exp].expense_payments[b_pay].amount).toFixed(2)}</span>
																</div>
															</div>
														))
													) : ''
												}
											</td>
											<td className="text-end tp2" >{parseFloat(collections.expense_values[exp].expense_total).toFixed(2)}</td>
										</tr>
									))
								}
								<tr>
									<td colSpan={3} className="tp2 bgy text-end"><span className="f20" >Total</span></td>
									<td className="bgy" >
										{
											collections.main.expense_total !== undefined && Object.keys(collections.main.expense_total).length > 0 ? (
												Object.keys(collections.main.expense_total).map((ex, exi) => (
													collections.main.expense_total[ex].amount > 0 ? (
														<div class="grid8by2 align-items-center justify-content-between bdr0-b py-1" key={`bpay_${exi}`} >
															<span className="tp2 " >{collections.main.expense_total[ex].name}</span>
															<div className="d-flex align-items-center justify-content-end" >
																<span className="tp2 " >{parseFloat(collections.main.expense_total[ex].amount).toFixed(2)}</span>
															</div>
														</div>
													) : ''
												))
											) : ''
										}
									</td>
									<td className="text-end bgy"><span className="f20" >{collections.main !== undefined ? parseFloat(collections.main.expense_day_total).toFixed(2) : ''}</span></td>
								</tr>
							</tbody>
						</Table>
					</>
				) : ''
			}
		</div>
	)
}